import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface OtherEventIconProps extends SvgIconProps {
  htmlColor?: string;
}

export default function OtherEventIcon({
  htmlColor,
  fontSize = "medium",
  ...other
}: OtherEventIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize={fontSize} {...other}>
      <path
        fill="none"
        d="M6 2H14L18 6V20C18 21 17 22 16 22H6C5 22 4 21 4 20V4C4 3 5 2 6 2Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M14 2V6H18"
        stroke={htmlColor || "currentColor"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M7.5 11H14.5"
        stroke={htmlColor || "currentColor"}
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M7.5 14H14.5"
        stroke={htmlColor || "currentColor"}
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M7.5 17H12"
        stroke={htmlColor || "currentColor"}
        strokeWidth="1"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
